import { useDispatch } from "react-redux";
import ios from './ios.svg';
import googlePlay from './google-play.svg';
import './MobileAppCallToAction.scss';
import { Images } from "src/Tenants";
import Icon from "../Icon";
import { exitPropertyWalkThroughForm } from "src/store/actions/propertyWalkThroughForm";
import { exitEasyWalkThroughForm } from "src/store/actions/easyWalkThroughForm";

interface IMobileAppCallToActionProps {
  header?: string;
}

export const MobileAppCallToAction: React.FC<IMobileAppCallToActionProps> = ({
  header='Download the mobile app',
}) => {
  const dispatch = useDispatch();

  const goBack = () => {
    // this is legacy code, will need to be updated as part of 
    // https://app.asana.com/0/1208712340140532/1209803742326178/f
    dispatch(exitPropertyWalkThroughForm());
    dispatch(exitEasyWalkThroughForm());
  }

  return (
    <div className="mobile-app-call-to-action">
      <div 
        className="mobile-app-call-to-action__back"
        onClick={()=>goBack()}
        >
        <Icon glyph='arrow-left' weight='solid' size="medium"/>
      </div>
      <div className="mobile-app-call-to-action__content">
        <div className="mobile-app-call-to-action__right">
          <h1>{header}</h1>
          <p>
            Download the mobile app to log deficiencies, and complete walkthroughs on the go.
          </p>
          <div className="mobile-app-call-to-action__buttons">
            <a href="https://apps.apple.com/ca/app/home-inspector-by-juniper/id6443896745" target="_blank">
              <img src={ios} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.juniper&hl=en_CA" target="_blank">
              <img src={googlePlay} />
            </a>
          </div>
          <a href="https://knowledge.spark.re/juniper-home-inspector-app" target="_blank">Learn More</a>
        </div>
      </div>
    </div>
  )
}
